import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import adminNotification from 'store/modules/admin-notification';
import adminProductCategory from 'store/modules/admin-product-category';
import adminProduct from 'store/modules/admin-product';
import admin from 'store/modules/admin';
import commonMessageDialog from 'store/modules/common-message-dialog';
import courseApplication from 'store/modules/course-application';
import course from 'store/modules/course';
import elearningApplication from 'store/modules/elearning-application';
import loading from 'store/modules/loading';
import medicalCheck from 'store/modules/medical-check';
import partner from 'store/modules/partner';
import productCategory from 'store/modules/product-category';
import product from 'store/modules/product';
import shop from 'store/modules/shop';
import shoppingOrder from 'store/modules/shopping-order';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    adminNotification,
    adminProductCategory,
    adminProduct,
    admin,
    commonMessageDialog,
    courseApplication,
    course,
    elearningApplication,
    loading,
    medicalCheck,
    partner,
    productCategory,
    product,
    shop,
    shoppingOrder,
  },

  // `createPersistedState()`でインスタンス作成。引数に設定を書く
  plugins: [
    createPersistedState({
      // ストレージのキーを指定。デフォルトではvuex
      key: 'bsac',
      // 管理対象のステートを指定。pathsを書かない時は`modules`に書いたモジュールに含まれるステート全て。`[]`の時はどれも保存されない
      paths: [
        'admin',
        'elearningApplication.applicant',
        'elearningApplication.course',
        'elearningApplication.diveCenter',
        'elearningApplication.emergency',
        'elearningApplication.rental',
        'elearningApplication.payBy',
        'elearningApplication.registerResponse',
        'courseApplication.applicant',
        'courseApplication.course',
        'courseApplication.diveCenter',
        'courseApplication.emergency',
        'courseApplication.rental',
        'courseApplication.payBy',
        'courseApplication.registerResponse',
        'medicalCheck.questions',
        'partner',
        'productCategory',
        'product',
        'shop',
        'shoppingOrder.applicant',
        'shoppingOrder.cartItems',
        'shoppingOrder.delivery',
        'shoppingOrder.payment',
      ],
      // ストレージの種類を指定する。デフォルトではローカルストレージ
      storage: window.sessionStorage,
    }),
  ],
});
